import logger from '../common/logger';

const TikTokEventMappings = {
  'Landing Page': {
    tiktokEventName: 'ViewContent',
  },
  'Custom Landing Page': {
    tiktokEventName: 'ViewContent',
  },
  'Presell Page': {
    tiktokEventName: 'ViewContent',
  },
  'Listicle Landing': {
    tiktokEventName: 'ViewContent',
  },
  'Splash Page': {
    tiktokEventName: 'ViewContent',
  },
  'Select Bundle': {
    tiktokEventName: 'AddToCart',
  },
  'Initiate Checkout': {
    tiktokEventName: 'InitiateCheckout',
  },
  'Shipping Info': {
    tiktokEventName: 'AddPaymentInfo',
  },
  'Order Conversion': {
    tiktokEventName: 'CompletePayment',
  },
};
const module = 'TiktokTracker';
const TikTokTracker = {
  pixelConfig: null,
  enabled: false,
  load: (pixelConfig, async = true) => {
    try {
      if (!pixelConfig || !pixelConfig?.pixelId) {
        return;
      }
      TikTokTracker.pixelConfig = pixelConfig;
      TikTokTracker.enabled = true;
      /* eslint-disable */
      !function (w, d, t) {
        w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"], ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }; for (var i = 0; i < ttq.methods.length; i++)ttq.setAndDefer(ttq, ttq.methods[i]); ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e }, ttq.load = function (e, n) { var i = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {}; var o = document.createElement("script"); o.type = "text/javascript", o.async = async, o.src = i + "?sdkid=" + e + "&lib=" + t; var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a) };


        ttq.load(TikTokTracker.pixelConfig.pixelId);
        ttq.page();
      }(window, document, 'ttq');
      /* eslint-enable */
    } catch (e) {
      logger.error('load Failed', e, { module });
    }
  },
  trackEvent: (eventProperties) => {
    try {
      if (!TikTokTracker.enabled) {
        return;
      }
      if (window.ttq) {

        // setup advanced matching
        const ttIdentity = {
          email: eventProperties?.enhancedConversionData?.email,
          phone_number: '+' + eventProperties?.enhancedConversionData?.phone_number
        };
        window.ttq.identify(ttIdentity);

        // track event
        const eventName = eventProperties.eventName;
        if (TikTokEventMappings?.[eventName]) {
          const ttEventName = TikTokEventMappings[eventName].tiktokEventName;
          let eventArgs = {};
          if (ttEventName === 'CompletePayment') {
            eventArgs = {
              currency: 'USD',
              value: TikTokTracker.getConversionValue()
            };
          }

          window.ttq.track(ttEventName, eventArgs);
          return { tiktokEventName: TikTokEventMappings[eventName].tiktokEventName, pixelConfig: TikTokTracker.pixelConfig };
        }
      }
    } catch (e) {
      logger.error('trackEvent Failed', e, { module });
    }
  },
  getConversionValue: () => {
    try {
      if (TikTokTracker?.pixelConfig?.value) {
        let value = TikTokTracker?.pixelConfig?.value;
        return parseFloat(value.replace('_', '.')).toFixed(2);
      } else {
        return 0.00;
      }
    } catch (e) {
      return 0.00;
    }
  },
};
export default TikTokTracker;